import { gql } from '@apollo/client'

export const REQUEST_RESOURCES_ZIP_MUTATION = gql`
  mutation createCompressedFile($input: [String]){
    createCompressedFile(resources: $input)
  }
`;